import { isBefore, subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const getFunnelSupportedDateRange = () => {
  const zonedTime = toZonedTime(new Date(), 'UTC');
  const supportedMinDate = toZonedTime(new Date('2024-11-14'), 'UTC');

  const maxDate = subDays(zonedTime, 1);
  const calculatedMinDate = subDays(zonedTime, 180);
  const isDateRangeExceeded = isBefore(calculatedMinDate, supportedMinDate);
  const minDate = isDateRangeExceeded ? supportedMinDate : calculatedMinDate;

  return { isDateRangeExceeded, maxDate, minDate };
};
